// src/App.js
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Home from './pages/Home';
import Header from './pages/Header';
import Footer from './pages/Footer';
import WomensHealth from './pages/WomensHealth';
import CarePackages from './pages/CarePackages';
import Services from './pages/Services';
import PreconceptionCare from './pages/care-packages/PreconceptionCare';
import AntenatalCare from './pages/care-packages/AntenatalCare';
import LabourCare from './pages/care-packages/LabourCare';
import PostnatalCare from './pages/care-packages/PostnatalCare';
import AdolescentCare from './pages/care-packages/AdolescentCare';
import ChildCare from './pages/care-packages/ChildCare';
import ScheduleConsultation from './pages/ScheduleConsultation';
import ContactUs from './pages/ContactUs';
import AboutUs from './pages/AboutUs';

function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow">
      <Header />
      <AuthProvider>
      <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/womens-health" element={<WomensHealth />} />
        <Route path="/care-packages" element={<CarePackages />} />
        <Route path="/services" element={<Services />} />
        <Route path="/preconception-care" element={<PreconceptionCare />} />
        <Route path="/antenatal-care" element={<AntenatalCare />} />
        <Route path="/labour-care" element={<LabourCare />} />
        <Route path="/postnatal-care" element={<PostnatalCare />} />
        <Route path="/adolescent-care" element={<AdolescentCare />} />
        <Route path="/child-care" element={<ChildCare />} />
        <Route path="/schedule-consultation" element={<ScheduleConsultation />} />
  <Route path="/contact" element={<ContactUs />} />
  <Route path="/about" element={<AboutUs />} />
      </Routes>
      </AuthProvider>
      </main>
      <Footer />
    </div>
  );
}

export default App;